import { clientConfig } from '../../../../config';

export const CARE_PROFILE_ASSET_BASE = `${clientConfig.IMAGES_URL}redesign_2025/care-plus/patient-dashboard`;

export const careProfileAsset = (name: string): string => `${CARE_PROFILE_ASSET_BASE}/${name}/${name}.png`;

export const localeByLanguage: Record<string, string> = {
  de: 'de-DE',
  en: 'en-GB', // English is served to the UK only
  fr: 'fr-FR',
};
